<template>
<div class="comments-container">
	<hr>
	<p class="mt-1 mb-1" v-if="reversedMessages.length > 0">
		<a v-if="commentsVisible" href="#" v-on:click.prevent="commentsVisible = false"><i class="fa fa-eye-slash"></i> Collapse Comments</a>
		<a v-else href="#" v-on:click.prevent="commentsVisible = true"><i class="fa fa-eye"></i> Show Comments ({{reversedMessages.length}})</a>
	</p>

	<div v-if="commentsVisible">
		<div v-if="comment.length > 0" class="mt-1">
			<field label="Add Users"
				col-class="col-3"
				:params="{type:'select-multi',options:userOptions(true)}"
				v-model="taggedUsers">
			</field>
		</div>
		<div class="d-flex flex-row">
			<field
				style="flex-grow: 1"
				:params="{type:'textarea',placeholder:'Write a comment...',size:commentSize}"
				v-model="comment">
			</field>
			<button v-if="comment.length > 0" type="button" v-on:click="saveComment" :disabled="savingComment" class="btn btn-success">
				<i v-if="savingComment" class="fa fa-spinner fa-spin"></i>
				Post
			</button>
		</div>
		
		<div v-if="reversedMessages.length > 0" class="comments">

			<div v-for="message in reversedMessages" class="comment-container">
				<div class="meta">
					<div>
						<router-link :to="'/employee/'+message.Author.slug+'/profile'" class="author">{{message.Author.first_name}} {{message.Author.last_name}}</router-link>
						<span class="datetime">{{formatDateTimeToLocal(message.created_at)}}</span>
					</div>
					<a href="#" v-on:click.prevent="deleteComment(message.id)" class="delete-comment">Delete</a>
				</div>
				<pre class="comment-text">{{message.message}}</pre>
			</div>

			<div class="members">
				Members:
				<router-link v-for="(member,index) in messageThread.Members" :key="'employees/'+member.slug+'/profile'" :to="'employees/'+member.slug+'/profile'">{{member.first_name}} {{member.last_name}}<span v-if="index < messageThread.Members.length-1">, </span></router-link>
			</div>
		</div>
	</div>

</div>
</template>
<script type="text/javascript">
import Field from "@/components/Field"

export default {
	name: "CommentThread",
	components: {
		Field
	},
	props: [
		"threadId",
		"parentModel",
		"parentSlug",
		"threadSubjectReference" //this will be appended to the created message thread subject
	],
	data() {
		return {
			messageThread: [],
			comment: "",
			commentsVisible: true,
			taggedUsers: [],
			usersBeingFetched: false,
			savingComment: false
		}
	},
	watch: {
		comment() {
			if (this.$store.users.length == 0 && !this.usersBeingFetched) {
				this.usersBeingFetched = true
				this.fetchUsers([],false,["id","slug","first_name","last_name"])
			}
		},
		threadId() {
			this.fetchThread()
		}
	},
	computed: {
		reversedMessages() {
			if (this.messageThread && "Message" in this.messageThread) {
				let messages = JSON.parse(JSON.stringify(this.messageThread.Message))
				return messages.reverse()
			}
			return []
		},
		commentSize() {
			if (this.comment.length < 40)
				return "xxsm"
			else if (this.comment.length < 120)
				return "sm"
			else
				return 'lg'
		}
	},
	methods: {
		saveMessage(message,thread_id) {
			let vm = this

			return new Promise((resolve,reject) => {
				if (message && thread_id) {
					let payload = {
						thread_id: thread_id,
						message: message
					}

					vm.savingComment = true

					this.postData("Message/save",payload,true).then(response => {						
						resolve(response)
					})
				}
				else
					resolve(false)
			})
		},
		syncMembers(memberIds,thread_id) {
			let vm = this

			let payload = {
				id: thread_id,
				Members: memberIds
			}

			return new Promise((resolve,reject) => {
				vm.postData("MessageThread/save",payload).then(response => {
					resolve(response)
				})
			})
		},
		saveComment() {
			let vm = this

			let members = []
			if (!this.messageThread || !this.messageThread.Members) {
				members = this.taggedUsers
				members.push(this.$store.userDetails.id)
			}
			else
				members = this.messageThread.Members.map(user => user.id)

			members = members.concat(this.taggedUsers)
			members.push(this.$store.userDetails.id)
			let duplicatesRemoved = []
			members.forEach(id => {
				if (duplicatesRemoved.indexOf(id) === -1 && id)
					duplicatesRemoved.push(id)
			})
			members = duplicatesRemoved

			if (this.messageThread && "id" in this.messageThread) {

				let promises = [
					this.saveMessage(this.comment,this.messageThread.id),
					this.syncMembers(members,this.messageThread.id)
				]

				Promise.all(promises).then(responses => {
					vm.fetchThread()
				})
			}
			else {
				if (this.parentSlug && this.parentModel) {

					let threadPayload = {
						created_by: this.$store.userDetails.id,
						subject:  this.threadSubjectReference,
						is_open_thread: 0,
						is_comment_thread: 1,
						comment_parent_slug: this.parentSlug,
						comment_parent_model: this.parentModel,
						Members: [this.$store.userDetails.id]	
					}

					this.postData("MessageThread/save",threadPayload).then(response => {
						if (response.success) {

							let parentPayload = {
								slug: vm.parentSlug,
								message_thread_id: response.data.record_id
							}

							let promises = [
								vm.saveMessage(vm.comment,response.data.record_id),
								vm.syncMembers(members,response.data.record_id),
								vm.postData(this.parentModel+"/save",parentPayload)
							]
			
							Promise.all(promises).then(responses => {
								vm.fetchThread()
							})
						}
					})
				}
			}
		},
		deleteComment(message_id) {
			let vm = this

			this.postData("Message/delete",{
				id: message_id
			}).then(response => {
				if (response.success)
					vm.fetchThread()
			})
		},
		fetchThread() {
			let vm = this

			let threadInclude = [
				{
					model: "Message",
					include: [{
						model: "User",
						fields: ["id","slug","first_name","last_name"]
					}]
				},
				{
					model: "User",
					fields: ["id","slug",'first_name','last_name']
				}
			]

			//if threadId is specified, we'll fetch it directly (slightly faster than the alternative)
			if (this.threadId > 0) {
				let params = {
					include: threadInclude
				}

				this.getJSON("MessageThread/find/"+this.threadId,params).then(response => {
					if (response.success)
						vm.messageThread = response.data

					vm.savingComment = false
					vm.comment = ""
				})
			}
			else { //otherwise we'll fetch it as an include of hte parent record

				let params = {
					fields: ["id","slug"],
					include: [{
						model: "MessageThread",
						include: threadInclude
					}]
				}

				this.getJSON(this.parentModel+"/find/"+this.parentSlug,params).then(response => {
					if (response.success) {
						vm.messageThread = response.data.MessageThread
					}
					vm.savingComment = false
					vm.comment = ""
				})
			}
		}
	},
	created() {
		this.fetchThread()
	}
}
</script>

<style scoped>
	.comments-container {
		background-color: #fff;
		border-radius: 2px;
		margin-top: 10px;
	}

	.comment-container {
		margin-top: 10px;
	}

	.meta {
		display: flex;
		justify-content: space-between;
		flex-direction: row;
	}

	.meta .author {
		font-weight: bold;
		display: inline-block;
		margin-right: 10px;
	}

	.meta .datetime,
	.meta .delete-comment {
		font-size: 11pt;
	}

	.comment-text {
		background-color: #ececec;
		padding: 8px;
		border-radius: 2px;
		box-shadow: 0px 0px 2px #606060;
		word-break: break-all;
		word-wrap: break-word;
		white-space: pre-wrap;
		word-break: keep-all;
	}

	.members {
		font-size: 11pt;
	}
</style>